module.exports = __webpack_public_path__ + "img/flag_pl.a7694555.svg";